import React from 'react';
import { Box, Heading, Text, Button, VStack, Center } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Center minH="100vh">
      <VStack spacing={6}>
        <Heading size="2xl" color="gray.600">
          404
        </Heading>
        <Heading size="lg">
          Page non trouvée
        </Heading>
        <Text color="gray.600" textAlign="center">
          La page que vous recherchez n'existe pas ou a été déplacée.
        </Text>
        <Button
          colorScheme="blue"
          onClick={() => navigate('/')}
        >
          Retour à l'accueil
        </Button>
      </VStack>
    </Center>
  );
};

export default NotFoundPage;